import { FileDescriptor } from '@dreryk/command-query-ws-api';
import {
   ExternalDocumentationStorageLimitExceededFault,
   PatientConsentDocumentAttachment,
   PatientConsentDocumentAttachmentCreateCommand,
   PatientConsentDocumentAttachmentRemoveCommand,
} from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { CertificateFault, useCertificateFaultHandlerMap } from '~libs.desktop.shared.account';

import { ExternalDocumentationStorageLimitExceededTranslation } from '../../../../../common/ExternalDocumentationStorageLimitExceededTranslation';

type UsePatientConsentDocumentAttachmentCreateCommandOptions = {
   consentDocumentId: number;
   onAuthorizationRequired: VoidFunction;
};

export const usePatientConsentDocumentAttachmentCreateCommand = (
   options: UsePatientConsentDocumentAttachmentCreateCommandOptions
): UseCqrsCommandResult<
   PatientConsentDocumentAttachment,
   FileDescriptor,
   CertificateFault | ExternalDocumentationStorageLimitExceededFault
> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new PatientConsentDocumentAttachmentCreateCommand();
         command.consentDocumentId = options.consentDocumentId;
         command.fileDescriptor = {
            file: parameters.file,
            name: parameters.name,
            contentLength: parameters.contentLength,
         };
         return command;
      },
      {
         onFault: {
            ...useCertificateFaultHandlerMap({
               onAuthenticationRequired: options.onAuthorizationRequired,
            }),
            'egabinet-patient-frontend-api:ExternalDocumentationStorageLimitExceededFault': () =>
               dispatchSnackbarNegativeEvent(<ExternalDocumentationStorageLimitExceededTranslation />),
         },
      }
   );
};

export const usePatientConsentDocumentAttachmentRemoveCommand = (): UseCqrsCommandResult<void, number> => {
   return useCqrsCommand((id) => {
      const command = new PatientConsentDocumentAttachmentRemoveCommand();
      command.id = id;
      return command;
   });
};
